import React from 'react';
import { motion } from 'framer-motion';
import { PurchaseToast } from './PurchaseToast';
export function Hero() {
  return <section className="relative min-h-fit bg-transparent text-slate-900 flex flex-col items-center justify-start md:justify-center px-4 pt-4 md:pt-12 pb-2 md:pb-4 overflow-hidden font-sans" data-id="element-85" data-mp="ej4mbu3165dv">
      <div className="flex flex-col items-center gap-2 mb-4 md:mb-6 text-center" data-id="element-86" data-mp="4mrsmw7hjrj4">
        <span className="text-blue-600 font-black tracking-wide text-xs md:text-sm" data-id="element-87" data-mp="12a0j75mcfqrz">
          🌎 Disponible en toda LATAM · Acceso digital inmediato
        </span>
        <span className="inline-flex items-center rounded-full bg-blue-50 border border-blue-100 px-3 py-1 text-[10px] md:text-xs font-black text-slate-700 uppercase tracking-wide" data-id="element-88" data-mp="x8jo5qqjiyjb">
          ⚗️ Sistema visual listo para docentes de Química · Educación secundaria
        </span>
      </div>

      <div className="max-w-5xl text-center mb-4 md:mb-6" data-id="element-89" data-mp="3czfm01cr0b73">
        <h1 className="text-3xl md:text-6xl lg:text-7xl font-black leading-[1.05] tracking-tight" data-id="element-90" data-mp="381e0zavri1sz">
          Pasa de horas preparando clases a tener{' '}
          <span className="text-blue-600" data-id="element-91" data-mp="3o7lrboupx2nw">tu próxima clase de Química</span>{' '}
          lista en <span className="text-blue-600" data-id="element-92" data-mp="3o59bpicfn4e0">solo 5 minutos.</span>
        </h1>
        <p className="text-slate-700 text-sm md:text-xl font-bold leading-snug mt-4 md:mt-6 max-w-4xl mx-auto" data-id="element-93" data-mp="39a35ovdc75ko">
          Encuentra en un solo lugar la explicación visual, la actividad y la
          evaluación que necesitas para enseñar Química con mayor claridad, sin
          comenzar desde cero.
        </p>
        
      </div>

      <div className="relative w-full max-w-[320px] md:max-w-[600px] mb-2 md:mb-5" data-id="element-94" data-mp="2qjv9yybyvhei">
        <img src="https://cdn.magicpatterns.com/uploads/vbZ7U3KLgjgcmhDhSJYBtu/mockup-quimica-visual-pro-optimizado.webp" alt="MegaPack Química Visual - Tomos, fichas, evaluaciones y juegos" width={1234} height={1234} loading="eager"
      // @ts-ignore
      fetchpriority="high" decoding="async" className="w-full h-auto mix-blend-multiply" data-id="element-95" data-mp="2qi0kd6pr3143" />
      </div>

      <p className="text-center text-slate-600 text-xs md:text-xl font-bold max-w-2xl mb-4 md:mb-6" data-id="element-96" data-mp="s2te9nr9cdqs">
        Todo el material que necesitas para tu próxima clase, organizado y listo
        para utilizar.
      </p>

      <motion.button animate={{
      boxShadow: ['0 0 15px rgba(34,197,94,0.2)', '0 0 30px rgba(34,197,94,0.5)', '0 0 15px rgba(34,197,94,0.2)'],
      scale: [1, 1.03, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} className="w-full max-w-xs md:max-w-md bg-green-600 hover:bg-green-700 active:scale-95 text-white font-black text-sm md:text-xl py-5 md:py-7 px-6 md:px-10 rounded-2xl shadow-[0_10px_30px_rgba(34,197,94,0.3)] flex items-center justify-center transition-all mb-2 text-center" data-id="element-97" data-mp="icrmolzp4d74">
        ⚗️ OBTENER ACCESO AHORA
      </motion.button>

      <p className="text-[10px] md:text-sm text-slate-600 font-bold text-center mb-3" data-id="element-98" data-mp="3hpsg79rvnz45">
        Acceso inmediato · PDF descargable · Pago único · Sin suscripción
      </p>

      <p className="text-[10px] md:text-sm text-slate-500 font-medium mb-4 md:mb-6 text-center" data-id="element-99" data-mp="21by07aom32dz">
        🔒 Garantía de satisfacción de 7 días. Si no es adecuado para ti, puedes
        solicitar la devolución.
      </p>

      <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 md:gap-x-10 md:gap-y-2 text-[9px] md:text-sm font-bold text-slate-500 animate-fade-in" data-id="element-100" data-mp="2b2aiew8yejgy">
        <div className="flex items-center gap-2" data-id="element-101" data-mp="2kyduouxiryhm">
          <span className="text-xl" data-id="element-102" data-mp="2kx2ge16g78c9">📄</span> 100% DIGITAL
        </div>
        <div className="flex items-center gap-2" data-id="element-103" data-mp="2p1k060ct5ln1">
          <span className="text-xl" data-id="element-104" data-mp="2oyo1uax1suy2">⚡</span> ACCESO INMEDIATO
        </div>
        <div className="flex items-center gap-2" data-id="element-105" data-mp="2tyshjyq4tln8">
          <span className="text-xl" data-id="element-106" data-mp="umzfvosefs46">🎓</span> EDUCACIÓN SECUNDARIA
        </div>
        <div className="flex items-center gap-2" data-id="element-107" data-mp="zlkke0eooxyf">
          <span className="text-xl" data-id="element-108" data-mp="zmc3wcv0b58c">🌎</span> CONVERSIÓN A MONEDA LOCAL
        </div>
      </div>

      <PurchaseToast data-id="element-109" data-mp="4a2u7jchl7z3" />
    </section>;
}